module.exports = __webpack_public_path__ + "img/icon_t2.62820515.png";